import React, { useState } from 'react';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import { useExports } from './hooks/useExports';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AppGrid } from './components/AppGrid';
import { CTAStrip } from './components/CTAStrip';
import { MyActivitySection } from './components/MyActivitySection';
import { CommunitySection } from './components/CommunitySection';
import { EcosystemBar } from './components/EcosystemBar';
import { Footer } from './components/Footer';
import { MobileNav } from './components/MobileNav';
import { AuthModal } from './components/AuthModal';
import { useScrollReveal } from './hooks/useScrollReveal';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import { useCounterPulse } from './hooks/useCounterPulse';

const PortalContent: React.FC = () => {
  const { session } = useAuth();
  const isLoggedIn = !!session;
  const exports = useExports();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  useScrollReveal();
  useSmoothScroll();
  useCounterPulse();

  const openAuth = () => setIsAuthModalOpen(true);
  const closeAuth = () => setIsAuthModalOpen(false);

  const userInitials = session?.user?.displayName
    ? session.user.displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : 'CR';

  return (
    <>
      <Header
        isLoggedIn={isLoggedIn}
        userInitials={userInitials}
        userName={session?.user?.displayName || 'Cris'}
        exportsUsed={exports.exportsUsed}
        exportsMax={exports.exportsMax}
        onOpenAuth={openAuth}
      />

      <main style={{ paddingTop: 'var(--fs-header-height)' }}>
        <HeroSection onOpenAuth={openAuth} />
        <AppGrid isLoggedIn={isLoggedIn} onOpenAuth={openAuth} />
        <CTAStrip onOpenAuth={openAuth} />
        <MyActivitySection exports={exports} isLoading={exports.isLoading} />
        <CommunitySection />
        <EcosystemBar />
        <Footer />
      </main>

      <MobileNav />

      <AuthModal isOpen={isAuthModalOpen} onClose={closeAuth} />
    </>
  );
};

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <PortalContent />
    </AuthProvider>
  );
};
